import { YHistoryEditor, YjsEditor } from '@slate-yjs/core';
import type { Editor } from 'slate';
import { HistoryEditor } from 'src/layout-engine/plugins/history/history-editor';

/**
 * Runs `fn` outside the undo history, then empties the history. Skipping the
 * save alone is not enough on a yjs editor: undoing an earlier tracked edit
 * skips the text `fn` already replaced but restores what that edit deleted, so
 * both end up side by side.
 */
export function withClearedUndoHistory(editor: Editor, fn: () => void): void {
  if (YHistoryEditor.isYHistoryEditor(editor)) YHistoryEditor.withoutSaving(editor, fn);
  else if (HistoryEditor.isHistoryEditor(editor)) HistoryEditor.withoutSaving(editor, fn);
  else fn();

  clearUndoHistory(editor);
}

/** Empties the editor's undo and redo history. */
export function clearUndoHistory(editor: Editor): void {
  if (YHistoryEditor.isYHistoryEditor(editor)) {
    // slate-yjs buffers ops until onChange; flush so the stack is final before clearing it.
    if (YjsEditor.connected(editor)) YjsEditor.flushLocalChanges(editor);
    editor.undoManager.clear(true, true);
    return;
  }
  if (!HistoryEditor.isHistoryEditor(editor)) return;

  editor.history.redos = [];
  editor.history.undos = [];
}
